import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { HelpState } from "./help.state";
import { getHelpCategories, getHelpContent, submitVote } from "./help.thunk";
import {
  GetHelpCategoriesResponse,
  GetHelpContentResponse,
  HelpCategory,
  HelpMain,
} from "./help.types";

const initialState: HelpState = {
  categories: null,
  categoriesStatus: "idle",
  content: null,
  contentStatus: "idle",
  error: null,
  searchQuery: "",
  main: null,
};

export const helpSlice = createSlice({
  name: "help",
  initialState,
  reducers: {
    resetHelp: (state) => {
      state.categories = null;
      state.categoriesStatus = "idle";
      state.content = null;
      state.contentStatus = "idle";
      state.error = null;
      state.searchQuery = "";
    },
    resetContent: (state) => {
      state.content = null;
      state.contentStatus = "idle";
    },
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload;
    },
    loadInitialHelpCategories: (
      state,
      action: PayloadAction<{ data: HelpCategory[]; main: HelpMain }>,
    ) => {
      if (state.categoriesStatus !== "idle") return;
      state.categories = action.payload.data;
      state.main = action.payload.main;
      state.categoriesStatus = "success";
    },
  },
  extraReducers: (builder) => {
    // Get Help Categories
    builder
      .addCase(getHelpCategories.pending, (state) => {
        state.categoriesStatus = "loading";
        state.error = null;
      })
      .addCase(
        getHelpCategories.fulfilled,
        (state, action: PayloadAction<GetHelpCategoriesResponse>) => {
          state.categoriesStatus = "success";
          state.categories = action.payload.data;
          // main her zaman gelir (arama sonucu boş olsa bile) — bir kez set edilince korunur
          if (action.payload.main) {
            state.main = action.payload.main;
          }
        }
      )
      .addCase(getHelpCategories.rejected, (state, action) => {
        state.categoriesStatus = "error";
        state.error =
          (action.payload as string) ??
          "Yardım kategorileri yüklenirken bir hata oluştu.";
      });

    // Get Help Content
    builder
      .addCase(getHelpContent.pending, (state) => {
        state.contentStatus = "loading";
        state.content = null;
        state.error = null;
      })
      .addCase(
        getHelpContent.fulfilled,
        (state, action: PayloadAction<GetHelpContentResponse>) => {
          state.contentStatus = "success";
          state.content = action.payload.data;
        }
      )
      .addCase(getHelpContent.rejected, (state, action) => {
        state.contentStatus = "error";
        state.error =
          (action.payload as string) ?? "İçerik yüklenirken bir hata oluştu.";
      });

    // Submit Vote
    builder.addCase(submitVote.pending, () => {
      // Loading handled in component
    });
  },
});

export const { resetHelp, resetContent, setSearchQuery, loadInitialHelpCategories } =
  helpSlice.actions;

export default helpSlice.reducer;